var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import SelectField from "../../../form/selectfield/SelectField";
function QuantitySelect(_a) {
    var _b = _a.cartQuantityMax, cartQuantityMax = _b === void 0 ? 5 : _b, _c = _a.label, label = _c === void 0 ? "Quantity" : _c, rest = __rest(_a, ["cartQuantityMax", "label"]);
    var maxQuantity = cartQuantityMax !== null && cartQuantityMax > 0 ? cartQuantityMax : 5;
    return (React.createElement(SelectField, __assign({ label: label }, rest), Array.from({ length: maxQuantity }, function (_, i) { return (React.createElement("option", { key: "oui_option_".concat(i), value: i + 1 }, i + 1)); })));
}
export default QuantitySelect;
//# sourceMappingURL=QuantitySelect.js.map